import { useTabState } from './useTabState';
import { useServicesData } from './useServicesData';
import { useBalanceDetail } from './useBalanceDetail';
import { useOwnerModal } from './useOwnerModal';
import { useTariffModal } from './useTariffModal';
import { useDiscountModal } from './useDiscountModal';
import { useStatusModal } from './useStatusModal';
import { useHistoryModal } from './useHistoryModal';

export function useClientCardController(idAccount: string | undefined) {
  const services = useServicesData(idAccount);
  const balance = useBalanceDetail(idAccount);
  const tabs = useTabState({ onEnterBalance: balance.reload });
  const ownerModal = useOwnerModal(idAccount, services.reload);
  const tariffModal = useTariffModal(services.reload);
  const discountModal = useDiscountModal(services.reload);
  const statusModal = useStatusModal(services);
  const historyModal = useHistoryModal();

  return {
    tabs,
    services,
    balance,
    ownerModal,
    tariffModal,
    discountModal,
    statusModal,
    historyModal,
  };
}

export type ClientCardController = ReturnType<typeof useClientCardController>;
